<div class="modal-associate" id="modal">
    <div class="modal__window-associate eventeditor-associate" cdkDrag>
        <a (click)='closeEvent($event)' class="button ghost close-icon desktop absolute right-0 m-0 cursor-pointer w-9 h-9 pl-[5px] border-0 bg-none shadow-none">
            <lucide-icon name="x" [size]="24"></lucide-icon>
        </a>
        <div class="content-height-associate" id="content-height">
            <section cdkDragHandle class="eventeditor__header-associate">
                <div class="menu">
                    <div>
                        <button *ngIf="this.title" (click)="deleteEvent()" type="submit" class="button delete-button mobile inline-block text-label border border-border-button bg-delete-btn w-full leading-[18px] h-[33px] text-[15px] font-bold text-left box-border py-[5px] px-2 rounded-md mt-0 cursor-pointer">
                            <lucide-icon name="trash-2" [size]="24" class="sprite-event-check-white"></lucide-icon>
                            <span class="button-event x-small text-left">Eliminar</span>
                        </button>
                    </div>
                    <div class="mr-[55px]">
                        <button (click)="saveEvent()" type="submit" class="button save-button mobile inline-block text-save-btn-font border border-save-btn bg-save-btn w-full leading-[18px] h-[33px] text-[15px] font-bold text-left box-border py-[5px] px-2 rounded-md mt-0 cursor-pointer">
                            <lucide-icon name="check" [size]="24" class="sprite-event-check-white"></lucide-icon>
                            <span class="button-event x-small text-left">Guardar</span>
                        </button>
                    </div>
                    <div>
                        <a (click)='closeEvent($event)' class="button ghost close-icon mobile absolute right-0 m-0 cursor-pointer w-9 h-9 pl-[5px] border-0 bg-none shadow-none">
                            <lucide-icon name="x" [size]="24"></lucide-icon>
                        </a>
                    </div>
                    <ng-content select="[a]"></ng-content>
                    &nbsp;
                </div>
            </section>
            <section class="eventeditor__content">
                <section class="title-input-associate">
                    <mat-form-field [style.fontSize]="13" appearance="fill" class="textarea">
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" [(ngModel)]="title" id="title" placeholder="Introduce el título del evento..."></textarea>
                    </mat-form-field>
                </section>
                <div class="visual-input-associate visual-input__left">
                    <div class="flex_content flex flex-row flex-wrap h-auto">
                        <div class="dates min-h-[75px] h-auto">
                            <div class="datesfrom">
                                <div class="flex_content flex flex-row flex-wrap h-auto">
                                    <lucide-icon name="clock" [size]="24" class="sprite-event-clock"></lucide-icon>
                                    <label class="date-label labelfrom from">Desde</label>
                                </div>
                                <div class="value date-from-value text-corporate-3 font-bold">
                                    <div class="datepicker">
                                        <input name="dateFrom" tabindex="2" type="hidden" class="flatpickr-input">
                                        <input id="select-dateFrom" (focus)="setActive(true,false)" class="input flatpickr-input" placeholder="{{this.dateFrom}}" tabindex="2" type="text">
                                        <div *ngIf="isActiveFrom" class="active" id="dateFrom-picker">
                                            <app-date-picker (dateSelected)="clickDateSelected($event)" (closeModal)="setCloseModal($event)"></app-date-picker>
                                        </div>
                                    </div>
                                    <div *ngIf="!allDay" class="select-widget timepicker from text-corporate-3 font-bold border-0 float-left">
                                        <select class="select-widget-input" [(ngModel)]='timeFrom' (change)="setTime(true, false)">
                                            <option [value]="item" *ngFor="let item of arrHoursFrom" class="select-option">{{item}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_content flex flex-row flex-wrap h-auto">
                                <div class="flex_content flex flex-row flex-wrap h-auto">
                                    <label class="date-label to">Hasta</label>
                                </div>
                                <div class="value date-to-value text-corporate-3 font-bold">
                                    <div class="datepicker">
                                        <input name="dateTo" tabindex="4" type="hidden" class="flatpickr-input">
                                        <input [disabled]="repeat" id="select-dateTo" (click)="setActive(false, true)" class="input flatpickr-input" placeholder="{{this.dateTo}}" tabindex="4" type="text">
                                        <div *ngIf="isActiveTo" class="active" id="dateTo-picker">
                                            <app-date-picker (dateSelected)="clickDateSelected($event)" (closeModal)="setCloseModal($event)"></app-date-picker>
                                        </div>
                                    </div>
                                    <div *ngIf="!allDay" class="select-widget timepicker to text-corporate-3 font-bold border-0 float-left">
                                        <select class="select-widget-input" [(ngModel)]='timeTo' (change)="setTime(false, true)">
                                            <option [value]="item" *ngFor="let item of arrHoursTo" class="select-option">{{item}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section class="eventeditor__sidebar">
                            <button (click)="saveEvent()" type="submit" class="button save-button inline-block text-save-btn-font border border-save-btn bg-save-btn w-full leading-[18px] h-[33px] text-[15px] font-bold text-left box-border py-[5px] px-2 rounded-md mt-0 cursor-pointer">
                                <lucide-icon name="check" [size]="24" class="sprite-event-check-white"></lucide-icon>
                                <span class="button-event text-left">Guardar</span>
                            </button>
                            <div *ngIf="this.title" class="title mt-[5px]">
                                <button (click)="deleteEvent()" type="submit" class="button delete-button inline-block text-label border border-border-button bg-delete-btn w-full leading-[18px] h-[33px] text-[15px] font-bold text-left box-border py-[5px] px-2 rounded-md mt-0 cursor-pointer">
                                    <lucide-icon name="trash-2" [size]="24" class="sprite-event-check-white"></lucide-icon>
                                    <span class="button-event text-left">Eliminar</span>
                                </button>
                            </div>
                        </section>
                    </div>
                    <div class="options-recurrence h-[81px] h-auto">
                        <div class="form__checkbox-associate all-day-label">
                            <div class="input all-day">
                                <input type="checkbox" class="check ml-2" id="all_day" name="all_day" value="0" [checked]="allDay" (change)="setAllDay($event, allDay=!allDay)">
                                <label for="all_day" tabindex="6">Todo el día</label>
                            </div>
                        </div>
                        <div class="visual-input-associate recurrence">
                            <div>
                                <div class="form__checkbox-associate recurrence-label">
                                    <div class="input all-day">
                                        <input type="checkbox" class="check ml-2" id="recurs" name="recurs" value="0" [checked]="repeat" (change)="changeRepeatCheck()">
                                        <label for="recurs" tabindex="7">Se repite</label>
                                        <div *ngIf="objParams.repeat && repeat" id='params' class="params pl-2">
                                            <a class="soft-button cursor-pointer underline text-label" (click)="goToRecurrence()">Mostrar</a>
                                        </div>
                                    </div>
                                </div>
                                <span>&nbsp;</span>
                            </div>
                        </div>
                        <div *ngIf="objParams.repeat? show: repeat" class="repeat-section">
                            <mat-tab-group selectedIndex="0" (selectedTabChange)="changeTab($event)" animationDuration="0ms">
                                <mat-tab label="Diariamente">
                                    <span>
                                        <app-recurrence-events [type]="type" [objParamsVar]="objParams" (objParams)="getParams($event)"></app-recurrence-events>
                                    </span>
                                </mat-tab>
                                <mat-tab label="Semanalmente">
                                    <span>
                                        <app-recurrence-events [type]="type" [objParamsVar]="objParams" (objParams)="getParams($event)"></app-recurrence-events>
                                    </span>
                                </mat-tab>
                                <mat-tab label="Mensualmente">
                                    <span>
                                        <app-recurrence-events [type]="type" [objParamsVar]="objParams" (objParams)="getParams($event)"></app-recurrence-events>
                                    </span>
                                </mat-tab>
                                <mat-tab label="Anualmente">
                                    <span>
                                        <app-recurrence-events [type]="type" [objParamsVar]="objParams" (objParams)="getParams($event)"></app-recurrence-events>
                                    </span>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                        <br>
                    </div>
                </div>
                <div class="visual-input-associate resources h-auto" id="visual-input-resources">
                    <lucide-icon name="list" [size]="24" class="icon-resource visual-input-icon"></lucide-icon>
                    <label class="resources-label">Calendario</label>
                    <div id="calendars-content" class="calendarpicker h-auto">
                        <div id="calendars-names" (click)="setOpenSelect(true)" class="select-control">
                            <div *ngIf="calendarsNamesSelectedArr.length">
                                <div id="list-names-selected" *ngFor="let nameselected of calendarsNamesSelectedArr" class="select-multi-value-wrapper">
                                    <div id="select-value" class="select-value">
                                        <span (click)="clickDeleteName(nameselected)" class="select-value-icon">×</span>
                                        <input id="select-input" type="text" class="select-value-label"> {{nameselected.name}}
                                    </div>
                                </div>
                                <div id="selected-name" style="display:none">
                                    <div *ngIf="openSelect" class="select-dropdown-names">
                                        <div class="names-option" *ngFor="let name of calendarsNamesArr">
                                            <div *ngIf="openSelect" class="select-option" (click)="setNames(name.name, name.idCalendar)">{{name.name}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="calendarsNamesSelectedArr.length==0">
                                <div id="select-value" class="select-value list">
                                    <span (click)="clickDeleteName(nameselected)" class="select-value-icon"></span>
                                    <input id="select-input" type="text" class="select-value-label"> {{calendarsNamesSelectedArr}}
                                </div>
                                <div id="selected-name" style="display:none">
                                    <div *ngIf="openSelect" class="select-dropdown-names">
                                        <div class="names-option" *ngFor="let name of calendarsNamesArr">
                                            <div *ngIf="openSelect" class="select-option" (click)="setNames(name.name, name.idCalendar)">{{name.name}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="eventeditor__rest">
                <div class="wysiwyg wycontent visual-input-associate">
                    <lucide-icon name="file-text" [size]="24" class="icon-description visual-input-icon"></lucide-icon>
                    <label class="label-description">Descripción</label>
                    <div>
                        <div>
                            <div class="wysiwyg wytext">
                                <input type="text" id='input3' name="description" [(ngModel)]="description" class="event-description" tabindex="24" rows="1" maxlength="255" placeholder="Descripción del evento..." />
                            </div>
                            <input type="hidden" name="notes" value="">
                        </div>
                    </div>
                </div>
                <div class="content-height-associate">
                    <div class="message">
                        {{message}}
                    </div>
                </div>
            </section>
            <section class="eventeditor__info" *ngIf="extendedProps">
                <div class="wysiwyg info">
                    <div *ngIf="extendedProps.idUserCreate" class="info-datetime">Evento creado por
                        <span><strong>{{extendedProps.idUserCreate.firstName}}, </strong> el {{createdDate}} a las {{createdTime}} hrs. </span>
                        <span *ngIf="extendedProps.idUserLastUpdate">Última actualización realizada por {{extendedProps.idUserLastUpdate.firstName}}, el {{updatedDate}} a las {{updatedTime}} hrs</span>
                    </div>
                </div>
            </section>
        </div>
        <div #messages></div>
        <div #seriesevents></div>
        <div #share></div>
    </div>
</div>